import { Component, OnInit, Input, DoCheck, ViewChild, EventEmitter } from '@angular/core';
import { GridDataResult, SelectionEvent } from '@progress/kendo-angular-grid';
import { SortDescriptor, orderBy } from '@progress/kendo-data-query';
import { Observable, Subscription } from 'rxjs';

import{ modalComponent } from '../../../../common/component/modal/modal.component';

import { UserProfileService, CustomersService, UsersService, UserModel, CustomerModel, initCustomerModel, UserActions} from '../../../../core';
import { CustomersStateService } from '../customers-state.service';
import { AddEditUserComponent} from './add-edit-user/add-edit-user.component'
import { UsersStateService } from './add-edit-user/users-state.service';

@Component({
  selector: 'app-users-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.scss']
})
export class UsersListComponent implements OnInit {
  @ViewChild(AddEditUserComponent, { static: false }) addEditUserComponent:AddEditUserComponent;
  @Input() currentCustomer:CustomerModel = initCustomerModel();

  subscriptions:Subscription[]=[];



  isSuperUser:boolean;
  gridViewUserList: GridDataResult;
  sortUserList: SortDescriptor[] = [];
  //@Input() UserList:UserModel[] = [];
  displayPane: number =0;
  userListBusyIndicator:{isBusy:boolean}={isBusy:true};

  showStyle={'display':'flex'};
  hideStyle= {'display': 'none'};
  addEditUserStyle:any= this.hideStyle;

  constructor(
    private userProfileService:UserProfileService
    ,private customerStateService: CustomersStateService
    ,private usersService:UsersService
    ,private usersStateService:UsersStateService
  ) { }

  ngOnInit() {
    this.isSuperUser = this.userProfileService.data.RoleList.includes("Super User");
    const s1 = this.customerStateService.busy
      .subscribe(busy =>
        this.userListBusyIndicator.isBusy = busy
      );
    const s2 = this.customerStateService.selectedCustomer
      .subscribe(customer => {
        this.currentCustomer = customer;
        this.OnUsersListChanged();
      });
    const s3 = this.usersStateService.userUpdated
      .subscribe(
        (user) =>{
          this.updateUserList(user);
          this.customerStateService.customerRefresh();
}
      );
    const s4 = this.usersStateService.hidingAddEditDialog
      .subscribe(
        (a) =>{
          this.displayAddEditUserComponent(false);
        }
      );
    this.subscriptions.push(s1,s2,s3,s4);
  }

  updateUserList(user:UserModel){
    let list = this.currentCustomer.UserList;
    if(user === null){
      var dd = 1;//this.switchToCustomer(this.currentCustomerIndex);
    }else{
      let foundIndx = -1;
      const found = list.find( (cust,i) => {foundIndx = i; return cust.UserID === user.UserID;});
      if(found){
        found.FirstName = user.FirstName;
        found.LastName = user.LastName;
        found.EMailAddress = user.EMailAddress;
        found.AccountStatusIDText = user.AccountStatusIDText;
        found.RoleString = user.RoleString;
        found.UserName = user.UserName;
      }
      else{
        list.push( user );
        this.setupSortedUserListGridView();
      }
    }
  }

  sortChangeUserList(sort: SortDescriptor[]): void {
        this.sortUserList = sort;
        this.setupSortedUserListGridView();
  }

  OnUsersListChanged(){
    //this.UserList = list;
    this.setupSortedUserListGridView();
  }

  setupSortedUserListGridView(){
    let list = this.currentCustomer.UserList;
    this.gridViewUserList = {
      data: orderBy(list, this.sortUserList),
      total: list.length
    }
  }

  linkUser(){
    this.addEditUserComponent.loadUserDopdown(this.currentCustomer.CustomerId);
    this.displayAddEditUserComponent();
  }

  displayAddEditUserComponent(show: boolean= true){
    this.addEditUserStyle = show?this.showStyle:this.hideStyle;
  }

  editUserClick(index){
    let activeUser:UserModel = this.gridViewUserList.data[index];
    this.addEditUserComponent.loadUser(activeUser.UserID, this.currentCustomer.CustomerId);
    this.displayAddEditUserComponent();
  }

 deleteUserClick(index:number){
    let activeUser:UserModel = this.gridViewUserList.data[index];
    this.updateUserFlagsDRYHelper(activeUser,activeUser.Deleted
      ,UserActions.Delete,UserActions.UnDelete
      ,"Are you sure you wish to delete the selected user account.","Are you sure you wish to undelete the selected user account."
      ,"Delete","Undelete"
      ,"Deleted","Undeleted"
      ,()=>{activeUser.Deleted = true;activeUser.AccountStatusIDText="Pending Deletion";if(!this.isSuperUser){this.gridViewUserList.data.splice(index,1)}},()=>{activeUser.Deleted = false;activeUser.AccountStatusIDText="Active";}
    );

  }
  suspendUserClick(index){
    let activeUser:UserModel = this.gridViewUserList.data[index];
    this.updateUserFlagsDRYHelper(activeUser,activeUser.Suspended
      ,UserActions.Suspend,UserActions.UnSuspend
      ,"Are you sure you wish to suspend the selected user account.","Are you sure you wish to reinstate the selected user account."
      ,"Suspend","Reinstate"
      ,"Suspended","Reinstated"
      ,()=>{activeUser.Suspended = true;activeUser.AccountStatusIDText="Suspended";},()=>{activeUser.Suspended = false;activeUser.AccountStatusIDText="Active"}
    );

  }
  lockUserClick(index){
    let activeUser:UserModel = this.gridViewUserList.data[index];
    this.updateUserFlagsDRYHelper(activeUser,activeUser.LockedOut
      ,UserActions.Lock,UserActions.UnLock
      ,"Are you sure you wish to lockout the selected user account.","Are you sure you wish to unlock the selected user account."
      ,"Lock Out","Unlock"
      ,"Locked Out","Reinstated"
      ,()=>{activeUser.LockedOut = true;activeUser.AccountStatusIDText="Locked Out";},()=>{activeUser.LockedOut = false;activeUser.AccountStatusIDText="Active"}
    );

  }
  updateUserFlagsDRYHelper(activeUser:UserModel, isUndo:boolean,
    doAction:number, undoAction:number,
    doAreSure:string, undoAreSure:string,
    doTitle:string, undoTitle:string
    ,doSubject:string, undoSubject:string
    ,doOnActionComplete:()=>void,undoOnActionComplete:()=>void
  )
  {
    if(!isUndo){
      this.updateUserLayer2(activeUser, doAction, doAreSure, doTitle + " Confirmation",doSubject, "User Successfully " + doSubject, "Unable To " + doTitle + " User", doOnActionComplete)
    }
    else{
      this.updateUserLayer2(activeUser, undoAction, undoAreSure, undoTitle + " Confirmation",undoSubject, "User Successfully " + undoSubject, "Unable To " + doTitle + " User", undoOnActionComplete)
    }

  }
  updateUserLayer2(activeUser:UserModel, action:UserActions, areYouSure:string, mbTitle:string, subject:string
                    , successmsg:string, failmsg:string, onComplete:()=>void)
  {
      let answerEvent = this.confirmDlg(areYouSure, mbTitle, true)
      if (!answerEvent ) return;
      answerEvent.subscribe(
        (userSaysOK)=>{
          if (userSaysOK) {
            this.userListBusyIndicator.isBusy = true;
          this.usersService.updateUserFlags(activeUser.UserID, action)
            .subscribe(
              (ok)=> {
                if(ok){
                  onComplete(); this.confirmDlg(successmsg, "Success").subscribe(()=>{});
                }
                else{
                  this.confirmDlg(failmsg, "Falied").subscribe(()=>{});
                }

                },
              (err) => {this.userListBusyIndicator.isBusy = false; console.log(err); this.confirmDlg(failmsg, "Falied").subscribe(()=>{})},
              ()=>this.userListBusyIndicator.isBusy = false
            )
          }
        }
      )
 }


   @ViewChild(modalComponent, { static: false }) modalController: modalComponent;

    public openModal:boolean=false;
    public kendoDialog:boolean=true;
    showMB:boolean = false;
    dialogTitle:string ="";
    dialogTextLine1:string = "";
    cancelButton:string = null;
    onDialogDone:EventEmitter<boolean> = null;
    okCloseButtonClick(ok:boolean){
      if (this.onDialogDone ) {
        this.showMB = false;
        this.openModal = false;
        this.onDialogDone.next(ok);
      }
    }
  confirmDlg(msg:string , title:string, cancelButton:boolean = false ):EventEmitter<boolean>{
    this.dialogTitle = title;
    this.dialogTextLine1 = msg;
    this.onDialogDone = new EventEmitter<boolean>();
    this.showMB = true;
    this.openModal = true;

    this.cancelButton = cancelButton?"Cancel":null;
    return this.onDialogDone;

  }
}
